import React, { useEffect, useRef, useState } from "react";
import BasePopup from "../Popup";
import bgCongPiece from "../../../../../assets/images/Mini-Game/bg-cong-piece.png";
import bgCongPieceEn from "../../../../../assets/images/Mini-Game/bg-cong-piece-en.png";
import bgCongPieceSuper from "../../../../../assets/images/Mini-Game/bg-cong-piece-super.png";
import bgCongPieceSuperEn from "../../../../../assets/images/Mini-Game/bg-cong-piece-super-en.png";
import iconClosePopup from "../../../../../assets/images/Mini-Game/icon-close-popup.svg";
import styled from "styled-components";
import iconPiece from "../../../../../assets/images/Mini-Game/delete-define-piece.png";
import bgBtn from "../../../../../assets/images/Mini-Game/bg-btn-piece-popup.png";
import bgBtnSuper from "../../../../../assets/images/Mini-Game/bg-btn-piece-popup-super.png";
import ButtonAction from "./components/ButtonAction";
import { useDispatch } from "react-redux";
import {
  setDataSpinLeft,
  setOpenPopupPiece,
} from "../../../../../Redux/futures/mini-game/action";
import {
  ID_GIFT_PLAY_LOTO_MINIGAME,
  ID_TAB_MINI_GAME,
  TYPE_DETAIL_PUZZLE_PIECE,
} from "../../../../../helper/const";
import iconBidFree from "../../../../../assets/images/Mini-Game/icon-bid-free.png";
import bgCoin from "../../../../../assets/images/Mini-Game/bg-coin-popup-cong.png";
import bgGoodluck from "../../../../../assets/images/Mini-Game/popup-good-luck-bg.png";
import iconGoodluck from "../../../../../assets/images/Mini-Game/popup-good-luck-icon.png";
import bgNoCoins from "../../../../../assets/images/Mini-Game/bg-no-coins.png";
import bgNoCoinsHead from "../../../../../assets/images/Mini-Game/bg-no-coin-head.png";
// import bgNoCoins from "../../../../../assets/images/Mini-Game/popup-no-coins-bg.png";
import PopupEarnMore from "./PopupEarnMore";
import { useNavigate } from "react-router";
import PATH from "../../../../../config/PATH";
import bgPuzzlePiece from "../../../../../assets/images/Mini-Game/bg-puzzle-piece.png";
import { useTranslation } from "react-i18next";
import { getTurnRemain } from "../../../../../Redux/futures/account/actions";
import { mediaQueryPoint, useMediaQuery } from "../../../../../utils/hooks";

export default function PopupCongPiece({
  isOpen = true,
  className,
  type,
  data,
}) {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [opacityItem, setOpacityItem] = useState((+type === ID_GIFT_PLAY_LOTO_MINIGAME.coin_super ||
    +type === ID_GIFT_PLAY_LOTO_MINIGAME.puzzle_piece) ? false : true)

  const onCancel = () => {
    dispatch(
      setOpenPopupPiece({
        isShowPopupPiece: false,
        type: null,
        data: {},
        turn: 0,
      })
    );
    if (type === ID_GIFT_PLAY_LOTO_MINIGAME.bid_free) {
      dispatch(getTurnRemain({}));
    }
    if (type === ID_GIFT_PLAY_LOTO_MINIGAME.add_spin) {
      const {
        spin_left = 0,
        spin_left_free = 0,
        spin_left_super = 0,
      } = data || {};

      dispatch(
        setDataSpinLeft({
          spin_left,
          spin_left_free,
          spin_left_super,
        })
      );
    }
  };

  const handleClickSeeAll = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.prizeCollection}`);
    onCancel();
  };

  const handleClickEarnMore = () => {
    navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`);
    onCancel();
  };

  const handleToBid = () => {
    navigate(PATH.HOME);
    onCancel();
  };

  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`);

  // quay super
  const elementRef = useRef(null);
  const [height, setHeight] = useState(0);
  useEffect(() => {
    if (
      elementRef.current &&
      (type === ID_GIFT_PLAY_LOTO_MINIGAME.coin_super ||
        type === ID_GIFT_PLAY_LOTO_MINIGAME.puzzle_piece)
    ) {
      let timeoutsetHeight = null;
      const handleGetTimeout = () => {
        timeoutsetHeight = setTimeout(() => {
          let elementHeight = elementRef.current.offsetHeight;

          // if(+elementHeight > 1000) {
          //   if(data?.name && data?.name.length < 21) {
          //     elementHeight = 440
          //   }
          //   else if( data?.name && data?.name.length < 40) {
          //     elementHeight = 508
          //   }
          // }
          // console.log("elementHeight", elementHeight);
          if (+elementHeight > 350 && count <= 5) {
            setCount(prev => prev + 1)
            handleGetTimeout();
          }
          if (+elementHeight > 1000) {
            if (data?.name && data?.name.length < 21) {
              elementHeight = 440
            }
            else if (data?.name && data?.name.length < 40) {
              elementHeight = 508
            }
          }
          const heightActive = +elementHeight + 160
          if (count === 5) {
            setOpacityItem(true)
          } if (count < 5) {
            setOpacityItem(false)
          }
          // console.log("heightActive", heightActive);

          setHeight(heightActive);
        }, [1000]);
      };
      handleGetTimeout();
      return () => clearTimeout(timeoutsetHeight);
    }
  }, [type, isOpen, isMobile, count]);

  if (!type) {
    return <></>;
  }

  let name = data?.bidProduct ? data?.bidProduct[0]?.product_name : "";
  if (!name) {
    name = data?.name ? data?.name : "";
  }

  const bg_lang = i18n.language === 'en' ? bgCongPieceEn : bgCongPiece
  const bg_lang_congPieceSuper = i18n.language === 'en' ? bgCongPieceSuperEn : bgCongPieceSuper

  return (
    // <div style={{opacity: `${opacityItem ? 1 : 0}`}}>
    <BasePopup
      BasePopup
      open={isOpen}
      className={className}
      onCancel={onCancel}
      getContainer
    >
      {type === ID_GIFT_PLAY_LOTO_MINIGAME.puzzle_piece ? (
        <Container height={height}>
          <div
            // style={{ display: "flex", justifyContent: "center" }}
            className="position-relative main-super-puzzle puzzle-piece-minigame"
          >
            <img src={bg_lang} alt="" className="bg-con-mini" />
            <img
              src={iconClosePopup}
              alt=""
              className="rule-mini-close button-hover__minigame"
              onClick={onCancel}
            />
            <div
              ref={elementRef}
              className="main-content-mini-piece main-content-mini-piece__puzzle-piece mini-piece-super-coin"
            >
              <div className="header">
                {data?.name || ""} - Piece {data?.obj_puzzle_piece?.name}{" "}1
                {t("mini_game.pop_up_received_pieces.normal")}
              </div>
              <div className="icon">
                <img
                  src={data?.obj_puzzle_piece?.image}
                  style={{ maxHeight: "160px", margin: "0 auto" }}
                  alt=""
                />
              </div>
              <div className="name">{data?.name || ""}</div>

              <div className="container-btn">
                <ButtonAction
                  srcBg={bgBtn}
                  content={t("mini_game.pop_up_received_pieces.see_all_prizes")}
                  handleClick={handleClickSeeAll}
                />
              </div>
              <div className="footer-popup-mini-cong">
                {t("mini_game.pop_up_received_pieces.footer_note")}
              </div>
            </div>
          </div>
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.coin_super ? (
        <Container height={height}>
          <div className="position-relative main-super-spin puzzle-piece-minigame">
            <img src={bg_lang_congPieceSuper} alt="" className="bg-super-con-mini" />

            <img
              src={iconClosePopup}
              alt=""
              className="rule-mini-close button-hover__minigame"
              onClick={onCancel}
            />
            <div
              className="main-content-mini-piece main-content-mini-piece-super-coin mini-piece-super-coin"
              ref={elementRef}
            >
              <div className="header">
                {t("mini_game.pop_up_received_pieces.super_prefix")}{" "}
                {data?.name || ""} - Piece {data?.obj_puzzle_piece?.name || ""}{" "}
                {t("mini_game.pop_up_received_pieces.super_suffix")}
              </div>
              <div className="icon">
                <img
                  style={{ maxHeight: "160px", margin: "0 auto" }}
                  src={data?.obj_puzzle_piece?.image}
                  alt=""
                />
              </div>
              <div className="name">{data?.name || ""}</div>

              <div className="container-btn container-btn-super-dowber">
                <ButtonAction
                  srcBg={bgBtn}
                  content={t("mini_game.pop_up_received_pieces.see_all_prizes")}
                  handleClick={handleClickSeeAll}
                />

                <ButtonAction
                  srcBg={bgBtnSuper}
                  content={t(
                    "mini_game.pop_up_received_pieces.earn_more_super"
                  )}
                  handleClick={handleClickEarnMore}
                />
              </div>
              <div className="footer-popup-mini-cong">
                {t("mini_game.pop_up_received_pieces.footer_note_super")}
              </div>
            </div>
          </div>
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.bid_free ? (
        <Container>
          <div className="popup-free-bid main-content-mini-piece__free-bid">
            <div
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img src={bg_lang} alt="" className="bg-con-mini" />
            </div>

            <img
              src={iconClosePopup}
              alt=""
              className="rule-mini-close button-hover__minigame"
              onClick={onCancel}
            />
            <div className="main-content-mini-piece ">
              {/* <div className='header'>{t("mini_game.pop_up_received_free_turns.prefix")}</div> */}
              <div className="name name-title" style={{ fontWeight: 500 }}>
                {t("mini_game.pop_up_received_free_turns.prefix")}{" "}
              </div>
              <div className="name name-content">
                {data.value}{" "}
                {t("mini_game.pop_up_received_free_turns.suffix").replace(
                  "s",
                  +data.value === 1 ? "" : "s"
                )}
              </div>
              <div className="name name-title" style={{ fontWeight: 500 }}>
                {t("mini_game.pop_up_received_free_turns.suffix_2")}
              </div>
              <div className="icon">
                <img src={iconBidFree} alt="" style={{ margin: "0 auto" }} />
              </div>
              <div className="header">
                {t("mini_game.pop_up_received_free_turns.promote").replace(
                  "XXX",
                  name
                )}
              </div>

              <div className="container-btn">
                <ButtonAction
                  srcBg={bgBtn}
                  content={t("mini_game.pop_up_received_free_turns.place_now")}
                  handleClick={handleToBid}
                />
              </div>
              <div className="footer-popup-mini-cong">
                {t("mini_game.pop_up_received_free_turns.winning_tip")}
              </div>
            </div>
          </div>
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.add_spin ? (
        <Container>
          <div className="popup-coins">
            <div
              className="container-bg"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img src={bg_lang} alt="" className="bg-con-mini" />
            </div>

            <img
              src={iconClosePopup}
              alt=""
              className="rule-mini-close button-hover__minigame"
              onClick={onCancel}
            />
            <div className="main-content-mini-piece">
              <div className="header">
                {t("mini_game.pop_up_received_coins.from_reel.prefix")}
              </div>
              <div className="name">
                {+data?.award?.value > 1
                  ? `${data?.award?.value} Coins`
                  : `${data?.award?.value} Coin`}
              </div>
              <div className="header">
                {t("mini_game.pop_up_received_coins.from_reel.suffix")}
              </div>
              <div className="icon">
                <img src={bgCoin} alt="" style={{ margin: "0 auto" }} />
              </div>

              <div className="container-btn">
                <ButtonAction
                  srcBg={bgBtn}
                  content={t(
                    "mini_game.pop_up_received_coins.earn_more_pieces"
                  )}
                  handleClick={onCancel}
                  className="button-action-popup-mini__coin"
                />
              </div>
            </div>
          </div>
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.good_luck ? (
        <Container>
          <div className="popup-good-luck">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img src={bgGoodluck} alt="" className="bg-con-mini" />
            </div>

            <img
              src={iconClosePopup}
              alt=""
              className="rule-mini-close button-hover__minigame"
              onClick={onCancel}
            />
            <div className="main-content-mini-piece">
              <div className="header">
                {t("mini_game.pop_up_good_luck.prefix")}
              </div>
              <div className="icon">
                <img src={iconGoodluck} alt="" style={{ margin: "0 auto" }} />
              </div>

              <div className="header">
                {t("mini_game.pop_up_good_luck.suffix")}
              </div>
            </div>
          </div>
        </Container>
      ) : type === ID_GIFT_PLAY_LOTO_MINIGAME.no_coins ? (
        <Container>
          <div className="popup-good-luck popup-no-coins">
            <div
              style={{ display: "flex", justifyContent: "center" }}
              className="bg-con-mini-wrapper"
            >
              <img src={bgNoCoinsHead} alt="" className="bg-con-mini" />
            </div>

            <img
              src={iconClosePopup}
              alt=""
              className="rule-mini-close button-hover__minigame"
              onClick={onCancel}
            />
            <div className="main-content-mini-piece">
              <PopupEarnMore isPopupNoCoins onCancel={onCancel} isPopupToRell />
            </div>
          </div>
        </Container>
      ) : type === TYPE_DETAIL_PUZZLE_PIECE ? (
        <Container>
          <div className="puzzle-piece-minigame popup-free-bid popup-puzzle-piece">
            <img src={bgPuzzlePiece} alt="" className="bg-con-mini" />
            <img
              src={iconClosePopup}
              alt=""
              className="rule-mini-close button-hover__minigame"
              onClick={onCancel}
            />
            <div className="main-content-mini-piece">
              <div className="header">
                {t("mini_game.pop_up_puzzle_piece.you_have")}
              </div>

              <div className="icon">
                <img src={data.image_light} alt="" style={{ margin: "0 auto" }} />
              </div>
              <div className="name" style={{ lineHeight: "32px" }}>
                {data.num || 0} Prize {data.awardName} - Piece (
                {data.name || ""})
              </div>
              <div style={{ marginTop: "25px" }}>
                <div className="container-btn detail-puzzle_piece">
                  <ButtonAction
                    srcBg={bgBtn}
                    content={t("mini_game.earn_more_pieces")}
                    handleClick={() => {
                      onCancel();
                      navigate(`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.home}`)
                    }}
                    className="button-action-popup-mini__item"
                  />
                </div>
                <div
                  style={{ marginTop: "25px" }}
                  className="footer-popup-mini-cong"
                >
                  {t("mini_game.pop_up_received_pieces.footer_note")}
                </div>
              </div>
            </div>
          </div>
        </Container>
      ) : null}
    </BasePopup>
    // </div>
  );
}

const Container = styled.div`
  position: relative;

  .container-btn-super-dowber {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;

    div {
      margin: 0 auto;
      display: flex;
      justify-content: center;
    }

    @media (max-width: 480px) {
      img {
        height: 50px;
      }
    }

    @media (max-width: 480px) {
      img {
        height: 38px;
      }
    }
  }

  .detail-puzzle_piece {
    .button-action-popup-mini__item {
      width: auto !important;
    }
  }

  .popup-coins {
    .container-bg {
      .bg-con-mini {
        height: 605px;
      }
    }
  }

  .popup-good-luck {
    .main-content-mini-piece {
      top: 220px;
    }

    .header {
      color: #1d2939;
    }

    .rule-mini-close {
      top: 50px;
      right: 20px;
    }
  }

  .popup-no-coins {
    background-image: url(${bgNoCoins});
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    padding: 60px 0 40px;

    .rule-mini-close {
      right: 5%;
      top: -20%;
      transform: translate(50%, -50%);
    }

    .bg-con-mini-wrapper {
      position: absolute;
      top: 0%;
      transform: translateY(-75%);

      .bg-con-mini {
        height: auto;
      }
    }

    .main-content-mini-piece {
      width: calc(100% - 60px);
      /* top: 195px; */
      top: 0 !important;
      position: relative;
    }

    .btn-container {
      button {
        padding: 10px 16px;
      }
    }

    .mission-icon {
      /* display: none; */
      display: grid;
      grid-template-columns: 50px calc(100% - 50px);
    }

    div .change-turn {
      margin-left: -52px;
    }

    .btn-cancel-change {
      margin-top: 10px;
    }

    .btn-confirm-change {
      margin-top: 15px;
    }

    .mini-icon-change {
      padding: 12px 0;
    }

    .coins-now-content {
      font-size: 24px;
      font-weight: 600;
      color: #101828;
      text-align: center;
    }

    .container-popup-mini-rule {
      margin-top: 10px;
      padding: 0 12px;
    }

    .container-icon-mission {
      width: 50px;
      height: 50px;

      img {
        width: 27px;
      }
    }

    .mission-name {
      font-size: 16px;
    }

    .mini-mission-footer {
      font-size: 14px;
    }

    .item-mission-container-mini {
      padding: 10px;
    }

    .flex-mission-icon {
      gap: 10px;
    }

    .change-turn {
      margin-left: -64px;
    }

    .warning-change-turn {
      font-size: 12px;
      padding: 10px 0;
    }

    @media (max-width: 450px) {
      div .btn-change-turn {
        font-size: 12px;
      }

      div .btn-total {
        /* font-size: 16px; */
      }
    }
  }

  .bg-con-mini {
    height: 668px;
  }

  .rule-mini-close {
    position: absolute;
    top: 10px;
    right: 0;
    z-index: 4;
  }

  .container-btn {
    margin: 10px 0;
    margin-bottom: 4px;
  }

  .footer-popup-mini-cong {
    text-align: center;
    font-style: italic;
    font-size: 14px;
    margin-top: 10px;
  }

  .name {
    text-shadow: -1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white,
      1px 1px 0 white;
    font-size: 28px;
    font-weight: bold;
    text-align: center;
  }

  .name-content {
    font-size: 24px;
    font-style: italic;
  }

  .name-title {
    font-size: 20px;
  }

  .icon {
    text-align: center;
    margin: 25px 0;
    margin-bottom: 20px;

    img {
      max-height: 245px;
      max-width: 100%;
    }
  }

  .main-content-mini-piece {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 155px;
    z-index: 2;
    font-size: 16px;
    color: #64310b;
    font-weight: 500;
  }

  .main-content-mini-piece__free-bid {
    .main-content-mini-piece {
      top: 130px;
    }

    .bg-con-mini {
      height: 710px;
    }
  }

  .main-content-mini-piece__puzzle-piece {
    width: calc(100% - 100px);
    text-align: center;
    justify-content: center;
    top: 140px;

    .container-btn {
      text-align: center;
      display: flex;
      justify-content: center;
    }
  }

  .bg-super-con-mini {
    height: 680px;
    width: 496px;
  }

  .header {
    font-weight: 500;
    text-align: center;
  }

  .main-super-puzzle {
    /* width: max-content; */
    margin: 0 auto;
    .bg-con-mini {
      min-height: 556px;
      height: ${(props) => `${props.height}px`};
      max-width: 90vw;

      @media (max-width: 768px){
        min-height: 350px;
      }
    }

    .container-btn {
      width: calc(100% - 30px);
      margin: 0 auto;
      max-width: 90%;
    }
  }

  .main-super-spin {
    .bg-super-con-mini {
      height: ${(props) => `${props.height}px`};
      min-height: 690px;
      max-width: 90vw;

      @media (max-width: 768px){
        min-height: 640px;
      }
    }

    .main-content-mini-piece {
    }
  }

  @media (max-width: 768px) {
    .popup-coins {
      .container-bg {
        .bg-con-mini {
          height: 500px;
        }
      }
      .main-content-mini-piece {
        top: 135px;
      }
    }

    .popup-free-bid {
      .main-content-mini-piece {
        top: 110px;
      }

      .footer-popup-mini-cong,
      .header {
        padding: 0;
        font-size: 14px;
      }
    }

    .popup-no-coins {
      margin: 0 -25px;
      background-size: 80% 100%;

      .rule-mini-close {
        right: 15%;
      }

      .bg-con-mini-wrapper {
        .bg-con-mini {
          max-width: 80%;
        }
      }

      .main-content-mini-piece {
        width: calc(100% - 20px);
        top: 0;
      }

      /* .btn-container button {
        width: 30px;
        height: 30px;
      } */

      /* .btn-total {
        height: 30px;
      } */

      .btn-change-turn {
        font-size: 14px;
      }

      .container-change-coins-mini .btn-change-turn {
        width: max-content;
      }

      .mini-change-coins-header {
        font-size: 13px;
      }

      .total-mini-change {
        font-size: 18px;
      }

      .bg-con-mini {
        height: 630px;
      }

      .header {
        font-size: 16px;
      }

      .coins-now-content {
        font-size: 20px;
      }

      .mission-name {
        font-size: 14px;
        line-height: 21px;
      }

      .mini-mission-footer {
        font-size: 12px;
      }

      .container-popup-mini-rule {
        padding: 0;
      }
    }

    .main-content-mini-piece {
      top: 150px;
      width: calc(100% - 55px);
    }

    .bg-con-mini {
      height: 525px;
    }

    .main-content-mini-piece__free-bid {
      .main-content-mini-piece {
        top: 115px;
      }

      .bg-con-mini {
        height: 610px;
      }
    }

    .main-content-mini-piece {
      max-width: 82%;
    }

    .main-content-mini-piece__puzzle-piece {
      margin-top: -20px;
    }

    .bg-super-con-mini {
      height: 640px;
      display: flex;
      justify-content: center;
      margin: 0 auto;
      text-align: center;
    }

    .icon {
      margin: 15px 0;
      margin-bottom: 5px;

      img {
        max-height: 150px;
      }
    }

    .button-action-popup-mini {
      min-height: 45px;
      width: 100% !important;
      text-align: center;

      /* img {
        height: 45px;
        width: 260px;
      } */
    }

    .footer-popup-mini-cong,
    .header {
      padding: 0 10px;
    }
  }

  @media (max-width: 576px) {
    .popup-free-bid.popup-puzzle-piece .name{
     font-size: 28px;
     line-height: 25px;
    } 

    .main-content-mini-piece.main-content-mini-piece-super-coin {
      /* top: 120px; */

      /* .icon img {
        max-height: 140px !important;
      }

      .name {
        font-size: 26px;
        line-height: 33px;
        padding: 5px 0;
      }

      .footer-popup-mini-cong {
        font-size: 13px;
      }

      .header {
        line-height: 22px;
      } */
    }
  }

  @media (max-width: 492px) {
    .popup-no-coins {
      max-width: 90dvw;
      margin: 0 auto;
      background-size: 100% 100%;
      padding-top: 50px;

      .rule-mini-close {
        right: 10%;
      }

      .bg-con-mini-wrapper {
        .bg-con-mini {
          max-width: 90%;
        }
      }

      .main-content-mini-piece {
      }
    }
  }

  @media (max-width: 452px) {
    .button-action-popup-mini {
      min-height: 45px;
      width: 100% !important;
      text-align: center;

      img {
        /* height: 45px; */
        width: 300px;
      }
    }

    .name {
      font-size: 26px;
      line-height: 33px;
      padding: 5px 0;
    }

    .footer-popup-mini-cong {
      font-size: 13px;
    }

    .header {
      line-height: 22px;
    }
  }

  @media (max-width: 440px) {
    .popup-no-coins {
      max-width: 95dvw;
      margin: 0 auto;
      background-size: 100% 100%;
      padding-top: 40px;

      .bg-con-mini-wrapper {
        .bg-con-mini {
          max-width: 100%;
        }
      }

      .main-content-mini-piece {
        padding: 0 10px;
      }
    }

    .name {
      font-size: 22px;
      line-height: 33px;
      padding: 0 0;
    }

    .header {
      line-height: 23px;
    }
  }

  @media (max-width: 412px) {
    .main-content-mini-piece.main-content-mini-piece-super-coin {
      top: 135px;
    }
    .button-action-popup-mini {
      img {
        height: 50px;
        width: 260px;
      }
    }
  }

  @media (max-width: 392px) {
    .popup-no-coins {
      .header {
        font-size: 14px;
      }

      .coins-now-content {
        font-size: 16px;
      }

      .warning-change-turn {
        margin-top: 5px;
        padding: 10px 10px;
        font-size: 11px;
      }
    }
  }

  .popup-puzzle-piece {
    .icon img {
      min-height: 120px;
    }

    .main-content-mini-piece {
      .header {
        font-size: 18px;
      }
    }

    .name {
      font-family: "Ganache", sans-serif;
      font-size: 36px;
      font-weight: 400;
    }
  }

  @media (max-width: 576px) {
    .popup-puzzle-piece {
    }
  }

  @media (max-width: 386px) {
    .popup-no-coins {
      .main-content-mini-piece {
        width: calc(100% - 20px);
        top: 175px;
      }
      .warning-change-turn {
        padding: 10px 0;
      }
    }
  }

  @media (max-width: 368px) {
    .popup-no-coins {
      .header {
        font-size: 12px;
      }

      .coins-now-content {
        font-size: 14px;
      }

      .warning-change-turn {
        padding: 10px 24px;
      }
    }
  }

  .puzzle-piece-minigame{

    .main-content-mini-piece{
      position: relative;
      top: 65px !important;
      /* max-width: calc(100% - 60px); */
      max-width: 100%;
      padding: 0 30px;
      width: auto;
      left: 50%;
      transform: translateX(-50%)
    }

    .bg-super-con-mini, .bg-con-mini{
      position: absolute;
      height: calc(100% + 160px);
      min-height: auto;
      max-height: calc(100% + 160px);
      width: calc(100%);
      top: -65px;
      left: 50%;
      transform: translateX(-50%)
    }

    .button-action-popup-mini{
      text-align: center;
      width: 100%;
    }

    .main-super-puzzle{
      width: auto !important;
    }

    .rule-mini-close{
      top: -46px;
    }
  }
`;
